import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";
import { api, fmt } from "../lib/api";
import { ChevronRight, Spade, Dices, Trophy } from "lucide-react";

const HERO_IMG = "https://images.pexels.com/photos/7313084/pexels-photo-7313084.jpeg";
const BJ_IMG = "https://images.pexels.com/photos/3678384/pexels-photo-3678384.jpeg";
const RL_IMG = "https://images.pexels.com/photos/7594180/pexels-photo-7594180.jpeg";
const SL_IMG = "https://images.pexels.com/photos/20843727/pexels-photo-20843727.jpeg";

export default function Landing() {
  const { lang, user, currency } = useApp();
  const [jackpot, setJackpot] = useState({ HUF: 5000000, EUR: 15000 });

  useEffect(() => {
    api.get("/games/slots/jackpot").then(r => setJackpot(r.data)).catch(()=>{});
  }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative min-h-[88vh] overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="" className="w-full h-full object-cover opacity-50"/>
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#050505]"/>
        </div>
        <div className="relative z-10 max-w-[1500px] mx-auto px-6 lg:px-10 pt-24 pb-32 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-[10px] uppercase tracking-[0.4em] text-[#d4af37] mb-6 font-medium">{t(lang,"landing.hero_kicker")}</div>
            <h1 data-testid="hero-title" className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] whitespace-pre-line">
              <span className="gold-text">{t(lang,"landing.hero_title")}</span>
            </h1>
            <p className="mt-8 text-white/70 max-w-xl text-base leading-relaxed">{t(lang,"landing.hero_sub")}</p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to={user ? "/lobby" : "/register"} data-testid="cta-play" className="btn-gold px-8 py-4 rounded-md inline-flex items-center gap-2 text-sm">
                {t(lang,"landing.cta_play")} <ChevronRight size={16}/>
              </Link>
              <Link to="/sports" data-testid="cta-sports" className="btn-ghost px-8 py-4 rounded-md text-sm uppercase tracking-widest">{t(lang,"nav.sports")}</Link>
            </div>
            <blockquote className="mt-16 italic text-[#d4af37]/70 font-serif text-lg max-w-md border-l-2 border-[#d4af37]/40 pl-5">
              "The world is yours." <span className="text-white/40 not-italic text-xs ml-2">— Tony Montana</span>
            </blockquote>
          </div>
          <div className="lg:col-span-5">
            <div className="lux-card jackpot-glow p-8 text-center">
              <div className="text-xs uppercase tracking-[0.4em] text-[#d4af37] mb-3">{t(lang,"landing.jackpot_title")}</div>
              <div className="font-serif text-4xl lg:text-5xl gold-text break-all" data-testid="jackpot-amount">
                {fmt(currency==="HUF"?jackpot.HUF:jackpot.EUR, currency)}
              </div>
              <div className="mt-4 text-white/40 text-xs">Live · Updating</div>
            </div>
          </div>
        </div>
      </section>

      {/* GAMES */}
      <section className="max-w-[1500px] mx-auto px-6 lg:px-10 py-24">
        <div className="mb-12">
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#d4af37] mb-3">VIP Selection</div>
          <h2 className="font-serif text-4xl lg:text-5xl gold-text">{t(lang,"landing.games_title")}</h2>
          <p className="text-white/50 mt-3">{t(lang,"landing.games_sub")}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { to:"/blackjack", img: BJ_IMG, name: t(lang,"bj.title"), icon:<Spade size={20}/> },
            { to:"/roulette", img: RL_IMG, name: t(lang,"roulette.title"), icon:<Dices size={20}/> },
            { to:"/slots", img: SL_IMG, name: t(lang,"slots.title"), icon:<Trophy size={20}/> },
          ].map(g => (
            <Link key={g.to} to={user?g.to:"/login"} data-testid={`game-card${g.to}`} className="lux-card overflow-hidden block group">
              <div className="aspect-[4/3] relative overflow-hidden">
                <img src={g.img} alt={g.name} className="w-full h-full object-cover group-hover:scale-110 transition duration-700"/>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent"/>
                <div className="absolute bottom-4 left-5 flex items-center gap-2 text-[#d4af37]">{g.icon}<span className="text-xs uppercase tracking-widest">VIP</span></div>
              </div>
              <div className="p-6 flex items-center justify-between">
                <h3 className="font-serif text-2xl">{g.name}</h3>
                <ChevronRight className="text-[#d4af37] group-hover:translate-x-1 transition"/>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
